export enum BookingStep {
  Order = "order",
  Payment = "payment",
  Refund = "refund",
  Discount = "discount",
  Promocode = "promocode",
  CompleteOrder = "complete-order",
  Teams = "teams",
  PromocodeCampaigns = "promocode-campaigns",
  Offers = "offers",
}

export enum OrderEditRights {
  HasRights = 1,
  OrderHasDiscount = 2,
  WrongTicketGroup = 3,
}

export enum BookingPaymentOptions {
  Paid,
  NotPaid,
  All,
}

export enum EmailTypes {
  Booking = "Booking",
  Invoice = "Invoice",
}
